module.exports = __webpack_public_path__ + "img/Brunei.86672c45.svg";